'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

let resetRequested = false;

export function requestNavigationScrollReset() {
    resetRequested = true;
}

export default function NavigationScrollReset() {
    const pathname = usePathname();

    useEffect(() => {
        if (!resetRequested) return;

        resetRequested = false;
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
}
